module.exports = __webpack_public_path__ + "static/media/breach.f4c83197.png";